module.exports = __webpack_public_path__ + "img/img_rank_3.65db181c.png";